import { JsonSchemaValidator } from "@common/json-schema-validator";
import { RoomId, StreamId } from "../../interface";
import { avcoreStreamApiCredentials, roomId, streamId } from "../../schema";
import { AvcoreSubcribeStreamApiCredentials } from "../../type";
import { BaseEntity } from "../base.entity";

export class RoomMixerStreamEntity extends BaseEntity<RoomMixerStreamEntityRaw> {
  private static validation = JsonSchemaValidator.compile(
    RoomMixerStreamEntity.schema()
  );

  static schema() {
    return {
      type: "object",
      required: ["id", "roomId", "credentials"],
      properties: {
        id: streamId,
        roomId,
        credentials: avcoreStreamApiCredentials
      },
      additionalProperties: false
    };
  }

  constructor(value: RoomMixerStreamEntityRaw) {
    super(JsonSchemaValidator.assert(RoomMixerStreamEntity.validation, value));
  }
}

export interface RoomMixerStreamEntityRaw {
  id: StreamId;
  roomId: RoomId;
  credentials: AvcoreSubcribeStreamApiCredentials;
}
